module.exports = __webpack_public_path__ + "static/img/pingjieshen4.e6434a3d.png";